import { n as removeTrapFocus, r as trapFocus } from "@theme/theme";
//#region frontend/islands/product-alternatives-drawer.js
var ProductAlternativesDrawer = class extends HTMLElement {
	constructor() {
		super();
		document.addEventListener("keyup", (evt) => evt.code === "Escape" && this.classList.contains("active") && this.close());
		this.querySelector("#ProductAlternativesDrawer-Overlay").addEventListener("click", this.close.bind(this));
		this.setTriggerAccessibility();
		this.initKeyboardNavigation();
	}
	initKeyboardNavigation() {
		this.addEventListener("keydown", (e) => {
			const target = e.target;
			if (target.tagName !== "INPUT" || target.type !== "radio") return;
			const radios = [...this.querySelectorAll("input[type='radio'][data-recipe-value]")];
			const idx = radios.indexOf(target);
			if (idx === -1) return;
			let next = null;
			if (e.key === "ArrowDown" || e.key === "ArrowRight") {
				e.preventDefault();
				next = radios[(idx + 1) % radios.length];
			} else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
				e.preventDefault();
				next = radios[(idx - 1 + radios.length) % radios.length];
			} else if (e.key === "Enter") {
				e.preventDefault();
				target.checked = true;
				target.dispatchEvent(new Event("change", { bubbles: true }));
			}
			if (next) next.focus();
		});
	}
	setTriggerAccessibility() {
		const trigger = document.querySelector("[data-product-alternatives-drawer-trigger]");
		if (!trigger) return;
		trigger.setAttribute("aria-haspopup", "dialog");
		trigger.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(trigger);
		});
	}
	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		setTimeout(() => {
			this.classList.add("active");
		});
		this.addEventListener("transitionend", () => {
			trapFocus(document.getElementById("ProductAlternativesDrawer"), this.querySelector("[tabindex=\"-1\"]"));
		}, { once: true });
		document.body.classList.add("overflow-hidden");
	}
	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}
	setActiveElement(element) {
		this.activeElement = element;
	}
};
window.customElements.define("product-alternatives-drawer", ProductAlternativesDrawer);
//#endregion
